import { useSettings, waLink } from "@/context/AppContext";
import SEO from "@/components/SEO";
import { PageHero, Reveal } from "@/components/Motion";
import QuoteForm from "@/components/QuoteForm";
import { MessageCircle, Phone, Mail, Clock } from "lucide-react";

export default function Quote() {
  const { settings } = useSettings();
  if (!settings) return <div className="min-h-screen bg-parchment" />;
  const biz = settings.business || {};
  const seo = settings.seo?.pages?.quote;

  return (
    <div data-testid="quote-page">
      <SEO title={seo?.title} description={seo?.description} path="/quote" />
      <PageHero eyebrow="Request a Quote" title="Get your export quotation." description="Share your product, quantity, packaging and destination details. Our export team will review your requirements and respond with a quotation." image={settings.hero?.image} />

      <section className="bg-parchment py-16 lg:py-24">
        <div className="mx-auto max-w-[1440px] px-4 sm:px-8 lg:px-16 grid gap-10 lg:grid-cols-3">
          <Reveal className="lg:col-span-2">
            <div className="border border-forest/10 bg-white p-6 sm:p-10">
              <QuoteForm />
            </div>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="space-y-4 lg:sticky lg:top-28">
              <div className="bg-forest p-8 grain relative" data-testid="quote-side-card">
                <p className="eyebrow">Prefer to talk first?</p>
                <div className="mt-6 space-y-4">
                  <a href={waLink(settings)} target="_blank" rel="noopener noreferrer" data-testid="quote-whatsapp-link" className="flex items-center gap-3 text-sm text-parchment/85 hover:text-gold-light transition-colors">
                    <MessageCircle className="h-4 w-4 text-gold" /> WhatsApp our export team
                  </a>
                  {(biz.phones || []).map((p) => (
                    <a key={p.tel} href={`tel:${p.tel}`} className="flex items-center gap-3 text-sm text-parchment/85 hover:text-gold-light transition-colors">
                      <Phone className="h-4 w-4 text-gold" /> {p.display}
                    </a>
                  ))}
                  <a href={`mailto:${biz.email}`} className="flex items-center gap-3 text-sm text-parchment/85 hover:text-gold-light transition-colors">
                    <Mail className="h-4 w-4 text-gold" /> {biz.email}
                  </a>
                </div>
              </div>
              <div className="border border-forest/10 bg-white p-8">
                <Clock className="h-5 w-5 text-gold-dark" />
                <p className="mt-3 font-serif text-xl text-forest">What happens next?</p>
                <ol className="mt-4 space-y-3 text-sm text-[#4A554D]">
                  <li className="flex gap-3"><span className="font-mono text-xs text-gold-dark">01</span> We review your requirements.</li>
                  <li className="flex gap-3"><span className="font-mono text-xs text-gold-dark">02</span> Our team contacts you to align on details.</li>
                  <li className="flex gap-3"><span className="font-mono text-xs text-gold-dark">03</span> You receive a professional export quotation.</li>
                </ol>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
